import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  dataIssuesDue: [],
  dataOverdueIssues: [],
  dataProcessOverview: [],
  dataIssuesOverview: [],
  dataIssuesOverviewByRisk: [],
  keyword: "",
  sortConfig: {
    key: "reportName",
    direction: "ASC",
  },
  loading: false,
};

export const DashboardMember = createSlice({
  name: "dashboard_member",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeDataIssuesDue: (state, action) => {
      state.dataIssuesDue = action.payload;
    },
    ChangeDataOverdueIssues: (state, action) => {
      state.dataOverdueIssues = action.payload;
    },
    ChangeDataProcessOverview: (state, action) => {
      state.dataProcessOverview = action.payload;
    },
    ChangeDataIssuesOverview: (state, action) => {
      state.dataIssuesOverview = action.payload;
    },
    ChangeDataIssuesOverviewByRisk: (state, action) => {
      state.dataIssuesOverviewByRisk = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeDataIssuesDue,
  ChangeDataOverdueIssues,
  ChangeDataProcessOverview,
  ChangeDataIssuesOverview,
  ChangeDataIssuesOverviewByRisk
} = DashboardMember.actions;

export default DashboardMember.reducer;
